import { ArrowRight, LogOut } from "lucide-react";

const LINKS = [
  { href: "#offer", label: "Offer", testid: "nav-offer-link" },
  { href: "#claim", label: "Claim", testid: "nav-claim-link" },
  { href: "#terms", label: "Terms", testid: "nav-terms-link" },
  { href: "#stores", label: "Stores", testid: "nav-stores-link" },
];

export const GoogleMark = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden>
    <path fill="#EA4335" d="M12 5.04c1.62 0 3.06.56 4.2 1.64l3.12-3.12C17.46 2.09 14.96 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.02 9.14 5.04 12 5.04z" />
    <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58l3.66 2.84c2.17-1.99 3.76-4.93 3.76-8.66z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09L2.18 7.07C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.66-2.84c-.98.66-2.23 1.06-3.62 1.06-2.86 0-5.29-1.98-6.16-4.53L2.18 16.93C3.99 20.53 7.7 23 12 23z" />
  </svg>
);

const Avatar = ({ user }) =>
  user.picture ? (
    <img src={user.picture} alt="" className="h-8 w-8 border border-white/20 object-cover" />
  ) : (
    <span className="flex h-8 w-8 items-center justify-center border border-white/20 font-heading text-xs font-bold text-[#FFCC00]">
      {user.name?.charAt(0)?.toUpperCase() || "U"}
    </span>
  );

export default function Header({ user, onLogin, onLogout }) {
  return (
    <header
      data-testid="site-header"
      className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:px-12">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3">
          <img src={`${process.env.PUBLIC_URL}/te_logo.png`} alt="Tyre Empire" className="h-7 w-auto" />
          <span className="hidden font-heading text-[10px] uppercase tracking-[0.3em] text-white/40 sm:block">
            Bengaluru
          </span>
        </a>
        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="font-heading text-xs font-semibold uppercase tracking-[0.25em] text-white/60 transition-colors duration-300 hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <div data-testid="user-menu" className="flex items-center gap-3">
              <Avatar user={user} />
              <span data-testid="user-name" className="hidden text-sm text-white/70 lg:block">
                {user.name}
              </span>
              <button
                data-testid="sign-out-button"
                onClick={onLogout}
                className="flex items-center gap-2 border border-white/20 px-4 py-2 font-heading text-xs font-bold uppercase tracking-[0.2em] text-white/70 transition-colors duration-300 hover:border-[#FF3B30] hover:text-[#FF3B30]"
              >
                <LogOut className="h-3.5 w-3.5" aria-hidden /> Sign Out
              </button>
            </div>
          ) : (
            <button
              data-testid="google-signin-button"
              onClick={onLogin}
              className="hidden items-center gap-2 border border-white/20 px-4 py-2.5 font-heading text-xs font-bold uppercase tracking-[0.15em] text-white/80 transition-colors duration-300 hover:border-white hover:text-white sm:flex"
            >
              <GoogleMark /> Sign In
            </button>
          )}
          <a
            href="#claim"
            data-testid="header-claim-button"
            className="group flex items-center gap-2 bg-[#FF3B30] px-5 py-2.5 font-heading text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-white hover:text-[#FF3B30]"
          >
            Claim Offer
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden />
          </a>
        </div>
      </div>
    </header>
  );
}
